import { render, staticRenderFns } from "./WaitingXhrPage.vue?vue&type=template&id=03f008d6&scoped=true&"
import script from "./WaitingXhrPage.vue?vue&type=script&lang=js&"
export * from "./WaitingXhrPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f008d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f008d6')) {
      api.createRecord('03f008d6', component.options)
    } else {
      api.reload('03f008d6', component.options)
    }
    module.hot.accept("./WaitingXhrPage.vue?vue&type=template&id=03f008d6&scoped=true&", function () {
      api.rerender('03f008d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/cart/components/WaitingXhrPage.vue"
export default component.exports